import type { ReactNode } from "react";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

interface KickerBadgeProps {
  children: ReactNode;
  className?: string;
}

/**
 * Lime kicker pill with a primary dot — used above section titles and on the quiz card.
 */
const KickerBadge = ({ children, className }: KickerBadgeProps) => (
  <Badge
    className={cn(
      "gap-2 bg-lime px-3 py-1 font-semibold uppercase tracking-wide text-lime-foreground",
      className
    )}
  >
    <span aria-hidden="true" className="size-1.5 rounded-full bg-primary" />
    {children}
  </Badge>
);

export default KickerBadge;
